import { api } from "@/_store/api-client";
import { ICreateSupportMessageRequest, ICreateSupportMessageResponse } from "./contracts";

export const supportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createSupportMessage: builder.mutation<ICreateSupportMessageResponse, ICreateSupportMessageRequest>({
      query: (requestBody) => ({
        url: "/api/v1/support/message/",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["CreateSupportMessage"],
    })
  }),
  overrideExisting: false,
});

export const { useCreateSupportMessageMutation } = supportApi;
